export const ENDPOINT = "https://bodega.bgajardo.com";
//export const ENDPOINT = "http://localhost:4000";